var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#3C3C3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact us",
    clipPath: "url(#clip0_155_1656)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2635,
    transform: "translate(-704 -1491)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 13.3926C28 22.7259 16 30.7259 16 30.7259C16 30.7259 4 22.7259 4 13.3926C4 10.21 5.26428 7.15773 7.51472 4.9073C9.76516 2.65686 12.8174 1.39258 16 1.39258C19.1826 1.39258 22.2348 2.65686 24.4853 4.9073C26.7357 7.15773 28 10.21 28 13.3926Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 17.3926C18.2091 17.3926 20 15.6017 20 13.3926C20 11.1834 18.2091 9.39258 16 9.39258C13.7909 9.39258 12 11.1834 12 13.3926C12 15.6017 13.7909 17.3926 16 17.3926Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_1656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2635,
    fill: "white",
    transform: "translate(-704 -1491)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.7a24f9303cc2466bdd992f71a88e3d06.svg";
export { ForwardRef as ReactComponent };